// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1pysR","box":"WorkspacesBox_box__1M2H2","node":"WorkspacesBox_node__1pLBJ"};